export default function clientCertificateFingerprint(value: string): string {
  if (
    /^[0-9A-F]{2}(:[0-9A-F]{2}){31}$/.test(value) ||
    /^[0-9a-f]{64}$/.test(value)
  ) {
    return "";
  }

  return "Improper format for fingerprint!";
}
